import { WeightBracketPrice } from "./weight-bracket-price.model";

export class WeightBracketPriceMapper {
  static map(data: any): WeightBracketPrice {
    return new WeightBracketPrice(data.name, data.value);
  }
}
